import React, { createContext, FC, useContext, useReducer, useState } from "react";

import { SummaryCase} from "../models";
import HubService from "../services/hub.service";
import selectedCasesReducer from "./teamQ/reducers/selectedCasesReducer";
import casesInFlightReducer from "./teamQ/reducers/casesInFlightReducer";
import displaySettingsReducer, { displaySettingsInitialState } from "./teamQ/reducers/displaySettingsReducer";
import useHubListeners from "./teamQ/hooks/useHubListeners";
import { useLoadData } from "./teamQ/hooks/useLoadData";
import filtersReducer, { filtersInitialState } from "./teamQ/reducers/filtersReducer";
import { TeamQContext } from "./teamQ/types";
import { StaticData, staticDataInitialState } from "../models/staticData";

const Context = createContext<TeamQContext>({} as TeamQContext);

export const useTeamQContext = (): TeamQContext => useContext(Context);

export const TeamQContextProvider: FC = ({ children }) => {
  const [singleCaseHubConnection] = useState(new HubService("CaseHub"));
  const [casesHubConnection] = useState(new HubService("CasesHub"));

  const [cases, setCases] = useState<SummaryCase[]>([]);
  const [loadingCases, setLoadingCases] = useState<boolean>(true);
  const [staticData, setStaticData] = useState<StaticData>(staticDataInitialState);
  const [totalCasesCount, setTotalCasesCount] = useState<number|null>(null);
  const [myCasesCount, setMyCasesCount] = useState<number|null>(null);

  const [dataLoad, setDataLoad] = useState(false);

  const [casesInFlight, casesInFlightDispatch] = useReducer(casesInFlightReducer, []);
  const [displaySettings, displaySettingsDispatch] = useReducer(displaySettingsReducer, displaySettingsInitialState);
  const [filters, filtersDispatch] = useReducer(filtersReducer, filtersInitialState);
  const [selectedCases, selectedCasesDispatch] = useReducer(selectedCasesReducer, []);

  const contextValue: TeamQContext = {
    state: {
      cases,
      casesInFlight,
      displaySettings,
      filters,
      loadingCases,
      myCasesCount,
      selectedCases,
      staticData,
      totalCasesCount,
    },
    dispatch: {
      casesInFlight: casesInFlightDispatch,
      displaySettings: displaySettingsDispatch,
      filters: filtersDispatch,
      selectedCases: selectedCasesDispatch,
    },
    actions: {
      load: () => {
        setLoadingCases(true);
        setDataLoad(true);
      },
      send: (params) => singleCaseHubConnection.send(params.type, params.payload),
    },
  };

  useHubListeners(casesHubConnection, singleCaseHubConnection, casesInFlightDispatch, setDataLoad);

  useLoadData(
    contextValue,
    dataLoad,
    setCases,
    setDataLoad,
    setLoadingCases,
    setStaticData,
    setTotalCasesCount,
    setMyCasesCount
  );

  return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};

export const TeamQConsumer = Context.Consumer;
